import { render, staticRenderFns } from "./WithoutResult.vue?vue&type=template&id=63720d7b&scoped=true"
import script from "./WithoutResult.vue?vue&type=script&lang=js"
export * from "./WithoutResult.vue?vue&type=script&lang=js"
import style0 from "./WithoutResult.vue?vue&type=style&index=0&id=63720d7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63720d7b",
  null
  
)

export default component.exports